import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import IconCircle from 'components/common/icon_circle'
import styles from './rounded_progress.less'
import { lerp } from 'shared/helpers/math_helpers'
import { formatPercent } from 'client/griffin'

const GRADIENT_START_COLOR = '#0061a1'
const GRADIENT_END_COLOR = '#21a7ff'

class RoundedProgress extends React.Component {
  static propTypes = {
    value: PropTypes.number,
    showPercentage: PropTypes.bool,
    showProgress: PropTypes.bool,
    compact: PropTypes.bool,
  }

  static defaultProps = {
    showPercentage: true,
    showProgress: true,
  }

  normalizedValue = () => {
    return this.props.value ? Math.min(1, this.props.value) : 0
  }

  render() {
    let percentage = Math.min(1, this.normalizedValue().toFixed(2))
    percentage = formatPercent(percentage)

    return (
      <div styleName="rounded-progress">
        {this.props.showProgress ? (
          <div styleName="meter">
            <canvas
              width="112"
              height="102"
              ref={meter => {
                this.meter = meter
              }}
              styleName="meter-canvas"
            />
            <div styleName="icon-circle-container">
              <IconCircle type="rocket" iconSize="big" />
            </div>
          </div>
        ) : (
          this.props.compact && (
            <div styleName="meter">
              <div styleName="icon-circle-container">
                <IconCircle type="rocket" iconSize="big" />
              </div>
            </div>
          )
        )}
        {this.props.showPercentage && this.props.showProgress ? (
          <div styleName="percentage">{percentage}</div>
        ) : (
          ''
        )}
      </div>
    )
  }

  updateMeter = () => {
    if (!this.meter) {
      return
    }

    const r = 52
    const centerX = 56
    const centerY = 56
    const startAngle = 2.22
    const endAngle = lerp(
      startAngle,
      Math.PI * 2 + 0.911,
      this.normalizedValue()
    )

    let ctx = this.meter.getContext('2d')
    ctx.clearRect(0, 0, 112, 102)
    if (this.normalizedValue() === 0) {
      return
    }

    ctx.beginPath()
    ctx.lineCap = 'round'
    ctx.arc(centerX, centerY, r, startAngle, endAngle, false)
    ctx.lineWidth = 8
    let gradient = ctx.createLinearGradient(8.4137, 109.7624, 103.5863, -7.642)
    gradient.addColorStop(0, GRADIENT_START_COLOR)
    gradient.addColorStop(1, GRADIENT_END_COLOR)
    ctx.strokeStyle = gradient
    ctx.stroke()
  }

  componentDidMount() {
    this.updateMeter()
  }

  componentDidUpdate() {
    this.updateMeter()
  }
}

export default cssModules(RoundedProgress, styles, { allowMultiple: true })
